import { scrollMixin, scrollEndHook, scrollNoHasListData, reset} from '$scroll';
import ProgramUrl from '@config/program-url';
import store from '@store';
export function diseasePublic(opts= {}){
  return {
    data(){
      return {
        ProgramUrl:ProgramUrl,
        pageAllData:{},
        headerHeight:'',//获取标题高度
      }
    },
    filters:{
      url:function(val){
        return 'https://dtb315.com/common/autoreg?redirect_url='+encodeURIComponent(val)+'&want_url=https%3A%2F%2Fjiaxiao.dtb315.com'
      }
    },
    computed: {
      staticPath(){
        return `${this.config.path.static}/img/disease`;
      },
    },
    methods:{
      //  获取除产品、资讯外数据
      getData:function(){
        this.$axios({
          url:'/api/column_ecosphere/column_ecosphere',
          params:{
            column_id:this.$route.query.id,
          }
        }).then((res)=>{

          if(res.data.code == 200) {
            this.pageAllData = res.data.data;
            if (!this.pageAllData.info) return console.error('/api/column_ecosphere/column_ecosphere: data.info 为 null.')
            this.$weChatShare({
              title: this.pageAllData.info.share_title,
              desc: this.pageAllData.info.share_content,
              imgUrl: this.pageAllData.info.share_img,
            });
          } else if(res.data.code == 10002) {
            this.$toast('未绑定手机');
            return false;
          }

        })
      },

      //获取当前的view层elm
      getLastViewElm() {
        const viewScrolls = document.querySelectorAll('.bv-view-scroll');
        if (viewScrolls && viewScrolls.length > 0) {
          return viewScrolls[viewScrolls.length - 1];
        }
        return null;
      },
      //关闭没有绑定手机号分享弹窗
      closeBindPhoneShare() {
        store.state.shareState = false;
      },
    },
    created(){
      this.getData();
    },
    updated(){
      //获取标题高度
      setTimeout(()=>{
        let header = document.querySelector('.bv-header-container');
        this.headerHeight = header.offsetHeight;
      },800);
    }
  }
}
